import { useSelector } from "react-redux";
import { authSelector } from "../../../store";
import { PermissionCommons } from "../../../types/Permission";

interface HasPermissionProps extends Partial<PermissionCommons> {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}
export const HasPermission = (props: HasPermissionProps) => {
  const { children, of, fallback } = props;
  const {
    data: { privileges },
  } = useSelector(authSelector);

  if ((of && privileges?.includes(of)) || of === "N/A") {
    return <>{children}</>;
  }
  return <>{fallback}</>;
};
